<div class="container" (click)="closeMenu()">
  <!-- Purple Banner -->
  <div class="banner">يرجى تسجيل الرقم الترفيهي في صورة الأصيل</div>
  <div class="comment-box" style="padding: 10px; background-color: #fec0bf">
    تعليق تجريبي
  </div>

  <!-- Profile Section -->
  <div class="profile-section">
    <div class="profile-header">
      <div class="profile-image-container">
        <div class="profile-image-placeholder"></div>
      </div>

      <div class="profile-info">
        <h2 class="customer-name">{{ customerName }}</h2>
        <div class="info-list">
          <div class="info-item">
            <span class="info-label"> اجمالي المبغ المستحق :</span>
            <span class="info-value">1300</span>
          </div>
          <div class="info-item">
            <span class="info-label">مسؤول المبيعات :</span>
            <span class="info-value">kareem.hany.elrouda-31</span>
          </div>
          <div class="info-item">
            <span class="info-label">مدرب التدريبات الخاصه :</span>
            <span class="info-value"></span>
          </div>
          <div class="info-item">
            <span class="info-label"> رقم العضويه :</span>
            <span class="info-value">20</span>
          </div>
          <div class="info-item">
            <span class="info-label">كود الدخول :</span>
            <span class="info-value">NO67734$</span>
          </div>
          <div class="info-item">
            <span class="info-label">رقم التليفون :</span>
            <span class="info-value">
              <a href="https://wa.me/201092532838" target="_blank"
                >01092532838</a
              >
            </span>
          </div>
        </div>
      </div>

      <div class="action-buttons">
        <div class="button-row">
          <button class="btn btn-orange" (click)="OpenAttachmentComponent()">
            اضافه مرفق
          </button>
          <button class="btn btn-green" (click)="OpenAddFollowupComponent()">
            اضافه متابعه
          </button>
          <button class="btn btn-blue" (click)="AddTicketComponent()">
            نذكره دعم
          </button>
          <button class="btn btn-red" (click)="OpenAddSubscriptionComponent()">
            إضافة اشتراك
          </button>
          <button class="btn btn-gray" (click)="openHistoryDialog()">
            سجل التغييرات
          </button>
          <button class="btn btn-purple" (click)="sendMessage()">
            ارسال رساله
          </button>

          <!-- زر القائمة المنسدلة -->
          <div class="dropdown-container" [class.active]="showDropdown">
            <button class="btn btn-more" (click)="toggleDropdown()">...</button>

            <!-- القائمة المنسدلة -->
            <div class="dropdown-menu" *ngIf="showDropdown">
              <button class="dropdown-item" (click)="addApplication()">
                <span>إضافة تعليق</span>
              </button>
              <button class="dropdown-item" (click)="addSalesTicket()">
                <span>إضافة تنبيه لمسؤول المبيعات</span>
              </button>
              <button class="dropdown-item" (click)="addTrainerTicket()">
                <span>إضافة تنبيه للمدرب</span>
              </button>
              <button class="dropdown-item" (click)="editRecord()">
                <span>تعديل</span>
              </button>
              <button class="dropdown-item" (click)="viewRecord()">
                <span>عرض</span>
              </button>
              <button class="dropdown-item danger" (click)="blockClient()">
                <span>حظر العميل</span>
              </button>
            </div>
          </div>
        </div>

        <!-- Backdrop للإغلاق عند الضغط خارج القائمة -->
        <div
          class="dropdown-backdrop"
          *ngIf="showDropdown"
          (click)="closeDropdown()"
        ></div>
      </div>
    </div>

    <!-- Tabs Section -->
    <mat-tab-group
      class="custom-tabs"
      dir="rtl"
      [(selectedIndex)]="activeTabIndex"
    >
      <mat-tab label="بيانات العضو"
        ><div class="page-wrapper">
          <div class="info-box">
            <div class="box-header">بيانات العميل</div>

            <div class="box-body">
              <div class="row">
                <span class="label">الشركة :</span><span class="value"></span>
              </div>
              <div class="row">
                <span class="label">الإسم الأول :</span
                ><span class="value">عميل اختبار</span>
              </div>
              <div class="row">
                <span class="label">الإسم الأوسط :</span
                ><span class="value"></span>
              </div>
              <div class="row">
                <span class="label">الإسم الأخير :</span
                ><span class="value"></span>
              </div>
              <div class="row">
                <span class="label">رقم العضوية :</span
                ><span class="value">1</span>
              </div>
              <div class="row">
                <span class="label">كود الدخول :</span
                ><span class="value">1</span>
              </div>
              <div class="row">
                <span class="label">رقم الهاتف :</span
                ><span class="value">01111111119</span>
              </div>
              <div class="row">
                <span class="label">البريد الإلكتروني :</span
                ><span class="value"></span>
              </div>
              <div class="row">
                <span class="label">الرقم القومي :</span
                ><span class="value"></span>
              </div>
              <div class="row">
                <span class="label">اسم المستخدم :</span
                ><span class="value"></span>
              </div>
              <div class="row">
                <span class="label">الرقم الأرضي :</span
                ><span class="value"></span>
              </div>
              <div class="row">
                <span class="label">البلد :</span
                ><span class="value">Egypt</span>
              </div>
              <div class="row">
                <span class="label">تاريخ الميلاد :</span
                ><span class="value">2026-02-02</span>
              </div>
              <div class="row">
                <span class="label">عنوان :</span><span class="value"></span>
              </div>
              <div class="row">
                <span class="label">عنوان إضافي :</span
                ><span class="value"></span>
              </div>
              <div class="row">
                <span class="label">الزيارات :</span
                ><span class="value">0</span>
              </div>
              <div class="row">
                <span class="label">النوع :</span><span class="value">ذكر</span>
              </div>
              <div class="row">
                <span class="label">اسم الطوارئ :</span
                ><span class="value"></span>
              </div>
              <div class="row">
                <span class="label">رقم هاتف الطوارئ :</span
                ><span class="value"></span>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>

      <mat-tab label="رياضي">
        <div class="table-container">
          <table class="data-table">
            <thead>
              <tr>
                <th>الإسم</th>
                <th>الحاله</th>
                <th>تاريخ البدء</th>
                <th>تاريخ الإنتهاء</th>
                <th>عدد مرات الحضور</th>
                <th>الدعوات المتبقيه</th>
                <th>ايام التجديد المتاحه</th>
                <th>المبلغ المدفوع</th>
                <th>الدين</th>
                <th>مسؤول المبيعات</th>
                <th>مدرب التدريبات الخاصة</th>
                <th>إجراء</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let subscription of subscriptions; let i = index"
                [class.highlight-row]="i === 0"
              >
                <td>{{ subscription.name }}</td>
                <td>{{ subscription.stage }}</td>
                <td style="white-space: nowrap">
                  {{ subscription.subscriptionDate }}
                </td>
                <td style="white-space: nowrap">{{ subscription.endDate }}</td>
                <td>
                  <span class="badge badge-blue">{{
                    subscription.subscriptionCount
                  }}</span>
                </td>
                <td>
                  <span class="badge badge-purple">{{
                    subscription.actualCount
                  }}</span>
                </td>
                <td>
                  <span class="badge badge-gray">{{
                    subscription.endedCount
                  }}</span>
                </td>
                <td>{{ subscription.numberOfSessions }}</td>
                <td>{{ subscription.totalSessions }}</td>
                <td>{{ subscription.procedureType }}</td>
                <td>{{ subscription.email }}</td>
                <td>
                  <div class="menu-container">
                    <button class="menu-btn" (click)="toggleMenu(i, $event)">
                      ⋮
                    </button>

                    <div class="dropdown-menu" *ngIf="selectedMenuIndex === i">
                      <button class="menu-item" (click)="useCashBack()">
                        Use CashBack
                      </button>
                      <button class="menu-item" (click)="usedInvitations()">
                        Used Invitations
                      </button>
                      <button class="menu-item" (click)="payments()">
                        Payments
                      </button>
                      <button class="menu-item" (click)="freezeHistory()">
                        Freeze History
                      </button>
                      <button class="menu-item" (click)="benefitUsage()">
                        Benefit Usage History
                      </button>
                      <button class="menu-item" (click)="changesLog()">
                        Changes Log
                      </button>
                      <button class="menu-item" (click)="attendanceHistory()">
                        Attendance History
                      </button>
                      <button class="menu-item" (click)="invitation()">
                        Invitation
                      </button>
                      <button class="menu-item" (click)="requestService()">
                        Request Service
                      </button>
                      <button class="menu-item" (click)="suspendSubscription()">
                        Suspend Subscription
                      </button>
                      <button class="menu-item" (click)="editSales()">
                        Edit Sales Representative
                      </button>
                      <button class="menu-item" (click)="editCoach()">
                        Edit Coach
                      </button>
                      <button class="menu-item" (click)="invoice()">
                        Invoice
                      </button>
                      <button class="menu-item" (click)="editPlanStart()">
                        Edit plan start date
                      </button>
                      <button class="menu-item" (click)="innerTransfer()">
                        Inner Transfer
                      </button>
                      <button class="menu-item" (click)="outerTransfer()">
                        Outer Transfer
                      </button>
                      <button class="menu-item" (click)="upgrade()">
                        Upgrade
                      </button>
                      <button class="menu-item" (click)="downgrade()">
                        Downgrade
                      </button>
                      <button class="menu-item" (click)="refund()">
                        Refund
                      </button>
                      <button class="menu-item" (click)="editBenefits()">
                        Edit Subscription Benefits
                      </button>
                      <button class="menu-item" (click)="editBenefitsInvoice()">
                        Edit Subscription Invoice Benefits
                      </button>
                      <button class="menu-item" (click)="cancelSubscription()">
                        Cancel Subscription
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </mat-tab>
      <mat-tab label="لياقه"
        ><!-- subscriptions.component.html -->
        <div class="table-container">
          <table class="data-table">
            <thead>
              <tr>
                <th>الإسم</th>
                <th>الحاله</th>
                <th>تاريخ البدء</th>
                <th>تاريخ الإنتهاء</th>
                <th>عدد مرات الحضور</th>
                <th>الدعوات المتبقيه</th>
                <th>ايام التجديد المتاحه</th>
                <th>المبلغ المدفوع</th>
                <th>الدين</th>
                <th>مسؤول المبيعات</th>
                <th>مدرب التدريبات الخاصة</th>
                <th>إجراء</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let subscription of subscriptions; let i = index"
                [class.highlight-row]="i === 0"
              >
                <td>{{ subscription.name }}</td>
                <td>{{ subscription.stage }}</td>
                <td style="white-space: nowrap">
                  {{ subscription.subscriptionDate }}
                </td>
                <td style="white-space: nowrap">{{ subscription.endDate }}</td>
                <td>
                  <span class="badge badge-blue">{{
                    subscription.subscriptionCount
                  }}</span>
                </td>
                <td>
                  <span class="badge badge-purple">{{
                    subscription.actualCount
                  }}</span>
                </td>
                <td>
                  <span class="badge badge-gray">{{
                    subscription.endedCount
                  }}</span>
                </td>
                <td>{{ subscription.numberOfSessions }}</td>
                <td>{{ subscription.totalSessions }}</td>
                <td>{{ subscription.procedureType }}</td>
                <td>{{ subscription.email }}</td>
                <td>
                  <div class="menu-container">
                    <button class="menu-btn" (click)="toggleMenu(i, $event)">
                      ⋮
                    </button>

                    <div class="dropdown-menu" *ngIf="selectedMenuIndex === i">
                      <button class="menu-item" (click)="useCashBack()">
                        Use CashBack
                      </button>
                      <button class="menu-item" (click)="usedInvitations()">
                        Used Invitations
                      </button>
                      <button class="menu-item" (click)="payments()">
                        Payments
                      </button>
                      <button class="menu-item" (click)="freezeHistory()">
                        Freeze History
                      </button>
                      <button class="menu-item" (click)="benefitUsage()">
                        Benefit Usage History
                      </button>
                      <button class="menu-item" (click)="changesLog()">
                        Changes Log
                      </button>
                      <button class="menu-item" (click)="attendanceHistory()">
                        Attendance History
                      </button>
                      <button class="menu-item" (click)="invitation()">
                        Invitation
                      </button>
                      <button class="menu-item" (click)="requestService()">
                        Request Service
                      </button>
                      <button class="menu-item" (click)="suspendSubscription()">
                        Suspend Subscription
                      </button>
                      <button class="menu-item" (click)="editSales()">
                        Edit Sales Representative
                      </button>
                      <button class="menu-item" (click)="editCoach()">
                        Edit Coach
                      </button>
                      <button class="menu-item" (click)="invoice()">
                        Invoice
                      </button>
                      <button class="menu-item" (click)="editPlanStart()">
                        Edit plan start date
                      </button>
                      <button class="menu-item" (click)="innerTransfer()">
                        Inner Transfer
                      </button>
                      <button class="menu-item" (click)="outerTransfer()">
                        Outer Transfer
                      </button>
                      <button class="menu-item" (click)="upgrade()">
                        Upgrade
                      </button>
                      <button class="menu-item" (click)="downgrade()">
                        Downgrade
                      </button>
                      <button class="menu-item" (click)="refund()">
                        Refund
                      </button>
                      <button class="menu-item" (click)="editBenefits()">
                        Edit Subscription Benefits
                      </button>
                      <button class="menu-item" (click)="editBenefitsInvoice()">
                        Edit Subscription Invoice Benefits
                      </button>
                      <button class="menu-item" (click)="cancelSubscription()">
                        Cancel Subscription
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </mat-tab>
      <mat-tab label="أخرى">
        <div class="table-container">
          <table class="data-table">
            <thead>
              <tr>
                <th>الإسم</th>
                <th>الحاله</th>
                <th>تاريخ البدء</th>
                <th>تاريخ الإنتهاء</th>
                <th>عدد مرات الحضور</th>
                <th>الدعوات المتبقيه</th>
                <th>ايام التجديد المتاحه</th>
                <th>المبلغ المدفوع</th>
                <th>الدين</th>
                <th>مسؤول المبيعات</th>
                <th>مدرب التدريبات الخاصة</th>
                <th>إجراء</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let subscription of subscriptions; let i = index"
                [class.highlight-row]="i === 0"
              >
                <td>{{ subscription.name }}</td>
                <td>{{ subscription.stage }}</td>
                <td style="white-space: nowrap">
                  {{ subscription.subscriptionDate }}
                </td>
                <td style="white-space: nowrap">{{ subscription.endDate }}</td>
                <td>
                  <span class="badge badge-blue">{{
                    subscription.subscriptionCount
                  }}</span>
                </td>
                <td>
                  <span class="badge badge-purple">{{
                    subscription.actualCount
                  }}</span>
                </td>
                <td>
                  <span class="badge badge-gray">{{
                    subscription.endedCount
                  }}</span>
                </td>
                <td>{{ subscription.numberOfSessions }}</td>
                <td>{{ subscription.totalSessions }}</td>
                <td>{{ subscription.procedureType }}</td>
                <td>{{ subscription.email }}</td>
                <td>
                  <div class="menu-container">
                    <button class="menu-btn" (click)="toggleMenu(i, $event)">
                      ⋮
                    </button>

                    <div class="dropdown-menu" *ngIf="selectedMenuIndex === i">
                      <button class="menu-item" (click)="useCashBack()">
                        Use CashBack
                      </button>
                      <button class="menu-item" (click)="usedInvitations()">
                        Used Invitations
                      </button>
                      <button class="menu-item" (click)="payments()">
                        Payments
                      </button>
                      <button class="menu-item" (click)="freezeHistory()">
                        Freeze History
                      </button>
                      <button class="menu-item" (click)="benefitUsage()">
                        Benefit Usage History
                      </button>
                      <button class="menu-item" (click)="changesLog()">
                        Changes Log
                      </button>
                      <button class="menu-item" (click)="attendanceHistory()">
                        Attendance History
                      </button>
                      <button class="menu-item" (click)="invitation()">
                        Invitation
                      </button>
                      <button class="menu-item" (click)="requestService()">
                        Request Service
                      </button>
                      <button class="menu-item" (click)="suspendSubscription()">
                        Suspend Subscription
                      </button>
                      <button class="menu-item" (click)="editSales()">
                        Edit Sales Representative
                      </button>
                      <button class="menu-item" (click)="editCoach()">
                        Edit Coach
                      </button>
                      <button class="menu-item" (click)="invoice()">
                        Invoice
                      </button>
                      <button class="menu-item" (click)="editPlanStart()">
                        Edit plan start date
                      </button>
                      <button class="menu-item" (click)="innerTransfer()">
                        Inner Transfer
                      </button>
                      <button class="menu-item" (click)="outerTransfer()">
                        Outer Transfer
                      </button>
                      <button class="menu-item" (click)="upgrade()">
                        Upgrade
                      </button>
                      <button class="menu-item" (click)="downgrade()">
                        Downgrade
                      </button>
                      <button class="menu-item" (click)="refund()">
                        Refund
                      </button>
                      <button class="menu-item" (click)="editBenefits()">
                        Edit Subscription Benefits
                      </button>
                      <button class="menu-item" (click)="editBenefitsInvoice()">
                        Edit Subscription Invoice Benefits
                      </button>
                      <button class="menu-item" (click)="cancelSubscription()">
                        Cancel Subscription
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </mat-tab>
      <mat-tab label="تذاكر الدعم"
        ><!-- support-tickets.component.html -->
        <div class="card">
          <div class="card-content">
            <span class="ticket-title">تذاكر الدعم</span>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="المتابعات">
        <!-- ticket-history.component.html -->
        <div class="history-container" dir="rtl">
          <!-- Header / Title -->
          <div class="header">
            <h2 class="title">المتابعات</h2>
          </div>

          <!-- Main content area -->
          <div class="content">
            <ng-container *ngIf="interactions.length === 0; else hasData2">
              <!-- Empty state (optional) -->
              <div class="empty">لا توجد نتائج حالياً</div>
            </ng-container>

            <ng-template #hasData2>
              <div class="interaction-list">
                <div class="interaction-item" *ngFor="let item of interactions">
                  <div class="username">{{ item.username }}</div>
                  <div class="status">{{ item.status }}</div>
                  <div class="datetime">
                    <span class="date">{{ item.date }}</span>
                    <span class="time">{{ item.time }}</span>
                  </div>
                  <div class="note">{{ item.note }}</div>
                </div>
              </div>
            </ng-template>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="تعليقات علي العميل">
        <div class="att-wrap" dir="rtl">
          <!-- Header -->
          <div class="att-header">
            <h2>تعليقات عن العميل</h2>
          </div>

          <!-- Content -->
          <div class="content">
            <ng-container *ngIf="interactions.length === 0; else hasData">
              <div class="att-empty">لا توجد نتائج حالياً</div>
            </ng-container>

            <ng-template #hasData>
              <div class="interaction-list">
                <div
                  class="interaction-item"
                  *ngFor="let item of interactions; let i = index"
                >
                  <!-- Top row: username + 3-dot menu -->
                  <div class="interaction-top">
                    <div class="username">{{ item.username }}</div>

                    <!-- 3-dot menu -->
                    <div class="att-menu-container">
                      <button
                        class="att-menu-btn"
                        (click)="toggleCommentMenu(i, $event)"
                      >
                        ⋮
                      </button>

                      <div
                        class="att-dropdown"
                        *ngIf="selectedCommentMenuIndex === i"
                      >
                        <button
                          class="att-dropdown-item att-edit"
                          (click)="
                            EditComment(item); selectedCommentMenuIndex = null
                          "
                        >
                          ✏️ تعديل
                        </button>
                        <button
                          class="att-dropdown-item att-delete"
                          (click)="
                            DeleteComment(item); selectedCommentMenuIndex = null
                          "
                        >
                          🗑 حذف
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Status -->
                  <div class="status">{{ item.status }}</div>

                  <!-- Date & Time -->
                  <div class="datetime">
                    <span class="date">{{ item.date }}</span>
                    <span class="time">{{ item.time }}</span>
                  </div>

                  <!-- Note -->
                  <div class="note">{{ item.note }}</div>
                </div>
              </div>
            </ng-template>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="مرفقات">
        <div class="att-wrap" dir="rtl">
          <div class="att-header">
            <h2>مرافقات</h2>
          </div>

          <div class="att-table-wrap">
            <table class="att-table">
              <thead>
                <tr>
                  <th>منشئ المرفق</th>
                  <th>التعليق على المرفق</th>
                  <th>اسم المرفق</th>
                  <th>وقت الإنشاء</th>
                  <th>إجراء</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let att of attachments; let i = index"
                  [ngClass]="{ 'att-row-danger': att.attachmentstatus == 0 }"
                >
                  <td>{{ att.createdBy }}</td>
                  <td>{{ att.comment }}</td>
                  <td class="att-filename">
                    <a [href]="att.attachmenturl" target="_blank">{{
                      att.fileName
                    }}</a>
                  </td>
                  <td class="att-datetime">{{ att.createdAt }}</td>
                  <td class="att-action">
                    <div class="att-menu-container">
                      <button
                        class="att-menu-btn"
                        (click)="toggleMenu(i, $event)"
                      >
                        ⋮
                      </button>

                      <div class="att-dropdown" *ngIf="selectedMenuIndex === i">
                        <button
                          class="att-dropdown-item att-delete"
                          (click)="
                            DeleteAttachment(att); selectedMenuIndex = null
                          "
                        >
                          🗑 حذف
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>

                <tr *ngIf="attachments.length === 0">
                  <td colspan="5" class="att-empty">لا توجد مرافقات حالياً</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="المكالمات">
        <div class="att-wrap" dir="rtl">
          <div class="att-header">
            <h2>المكالمات</h2>
          </div>

          <div class="att-table-wrap">
            <!-- ← استخدم att-table-wrap مش table-wrapper -->
            <table class="att-table">
              <!-- ← استخدم att-table مش calls-table -->
              <thead>
                <tr>
                  <th>تاريخ المكالمة</th>
                  <th>نوع المكالمة</th>
                  <th>منشئ المكالمة</th>
                  <th>المكالمة</th>
                  <th>إجراء</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let call of calls; let i = index">
                  <td class="att-datetime">{{ call.callDate }}</td>
                  <td>{{ call.callType }}</td>
                  <td>{{ call.creator }}</td>
                  <td>
                    <div class="call-player">
                      <audio
                        [id]="'call-audio-' + i"
                        [src]="call.callUrl"
                      ></audio>
                      <button class="call-play-btn" (click)="toggleAudio(i)">
                        {{ playingIndex === i ? "⏸" : "▶" }}
                      </button>
                      <span class="call-label">تشغيل المكالمة</span>
                    </div>
                  </td>
                  <td class="att-action">
                    <div class="att-menu-container">
                      <button
                        class="att-menu-btn"
                        (click)="toggleCallMenu(i, $event)"
                      >
                        ⋮
                      </button>

                      <div
                        class="att-dropdown"
                        *ngIf="selectedCallMenuIndex === i"
                      >
                        <a class="att-dropdown-item att-download"> ↓ تحميل </a>
                        <button
                          class="att-dropdown-item att-delete"
                          style="width: 100%"
                        >
                          × حذف
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>

                <tr *ngIf="calls.length === 0">
                  <td colspan="5" class="att-empty">
                    لا توجد مكالمات مسجلة حالياً
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>

    <!-- Table Section -->
  </div>
</div>
